export default "__VITE_ASSET__BsNpSG6O__"